import {CNavComponent} from "./c-nav.comp";
import {CFooterComponent} from "./c-footer.comp";
import {CBannerComponent} from "./c-banner.comp";
export const layoutComponents = [
    {
        tagName: 'c-nav',
        component: CNavComponent
    },
    {
        tagName: 'c-footer',
        component: CFooterComponent
    },
    {
        tagName: 'c-banner',
        component: CBannerComponent
    }
];
